module.exports = __webpack_public_path__ + "img/icon-restaurant-buffet.c05f35c5.png";